import React, { useState, useEffect, useRef } from 'react'
import './Process.css'
import p1 from '../Images/p1.png';
import p2 from '../Images/p2.png';
import p3 from '../Images/p3.png';
import p4 from '../Images/p4.png';
import p5 from '../Images/p5.png';

function Process() {
    const [active, setActive] = useState(0);
    const containerRef = useRef(null);
    const buttonsRef = useRef({});
    const data = [
        {
            id: 0,
            image: p1,
            heading: "FinTech & Banking",
            para: "We design secure, intuitive, and compliant digital experiences for financial platforms. From mobile banking apps to investment dashboards, our UI/UX solutions simplify complex processes, build user trust, and drive customer engagement."
        },
        {
            id: 1,
            image: p2,
            heading: "Healthcare & MedTech",
            para: "Our healthcare designs prioritize accessibility, usability, and compliance. We create patient portals, telemedicine apps, and medtech dashboards that improve workflows, enhance patient experiences, and ensure smooth doctor-patient interaction."
        },
        {
            id: 2,
            image: p3,
            heading: "eCommerce & Retail",
            para: "We craft conversion-focused shopping experiences with intuitive navigation, engaging visuals, and seamless checkout flows. Our eCommerce solutions boost customer retention and sales while reflecting your brand’s identity."
        },
        {
            id: 3,
            image: p4,
            heading: "Gaming & Esports",
            para: "From immersive interfaces to interactive community platforms, we design engaging gaming experiences that keep players hooked. Our esports solutions enhance user engagement, team collaboration, and community interaction."
        },
        {
            id: 4,
            image: p5,
            heading: "Education & E-Learning",
            para: "We create user-friendly, interactive learning platforms that make education accessible and engaging. Our e-learning designs support personalized learning journeys, gamified experiences, and smooth knowledge-sharing for all age groups."
        }
    ]
    useEffect(() => {
        const container = containerRef.current;
        const activeButton = buttonsRef.current[active];
        const lastId = data[data.length - 1].id;
        const firstId = data[0].id;

        if (!container || !activeButton) return;

        const containerRect = container.getBoundingClientRect();
        const buttonRect = activeButton.getBoundingClientRect();

        const isFullyVisible =
            buttonRect.left >= containerRect.left &&
            buttonRect.right <= containerRect.right;

        if (isFullyVisible) return; // Already fully visible — no need to scroll

        const offset = buttonRect.left - containerRect.left;
        const centerScroll = offset - container.clientWidth / 2 + buttonRect.width / 2;

        // Handle edge cases:
        if (active === lastId) {
            const scrollAmount =
                buttonRect.right - containerRect.right + 16; // 16px padding or gap if needed
            container.scrollTo({
                left: container.scrollLeft + scrollAmount,
                behavior: 'smooth',
            });
        } else if (active === firstId) {
            const scrollAmount =
                buttonRect.left - containerRect.left - 16;
            container.scrollTo({
                left: container.scrollLeft + scrollAmount,
                behavior: 'smooth',
            });
        } else {
            // Center scroll for all other buttons
            container.scrollTo({
                left: container.scrollLeft + centerScroll,
                behavior: 'smooth',
            });
        }
    }, [active]);

    return (
        <div id='uiProcess'>
            <div className="section">
                <div className="container">
                    {/* <h3 className="blueheading">
                        Our Work process
                    </h3> */}
                    <h1 className="heading">
                        Industries We Serve
                    </h1>
                    <p className="newpara">
                       UI/UX design services expertise spans multiple industries, delivering tailored digital experiences that drive results:
                    </p>
                    <div className="processBox">
                        <div className="headingbox">

                            <div className="headings" ref={containerRef}>
                                {
                                    data.map((items) => {
                                        return (
                                            <button
                                                type='button'
                                                ref={(el) => buttonsRef.current[items.id] = el}
                                                onClick={() => setActive(items.id)}
                                                className={`phead ${active === items.id ? 'activeHead' : ''}`}
                                                key={items.id}
                                            >{items.heading}</button>
                                        )
                                    })
                                }
                            </div>

                        </div>

                        <div className="processSlides">
                            <div className="slideWrapper" style={{ transform: `translateX(-${active * 100}%)` }}>
                                {data.map((item) => (
                                    <div className="process-card" key={item.id}>
                                        <div className="cardRight">
                                            <img src={item.image} alt={item.heading} />
                                        </div>
                                        <div className="cardLeft">
                                            <div>
                                                {/* <h3 className="blueheading">0{item.id + 1}</h3> */}
                                                <h1 className="heading">{item.heading}</h1>
                                            </div>
                                            <p className="newpara">{item.para}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Process